
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { EmbeddedVideoDialogComponent } from './embedded-video-dialog.component';
import { FormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
  declarations: [
    EmbeddedVideoDialogComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule
  ],
  exports: [EmbeddedVideoDialogComponent],
  providers: [],
})
export class EmbeddedVideoModalContentModule { }
